export enum AvatarCodes {
    avocado = "avocado",
    carambola = "carambola",
    draco = "draco",
}

export type AvatarCode = AvatarCodes.avocado | AvatarCodes.carambola | AvatarCodes.draco;
